<template>
  <div class="automated-email-filters-ui">
    <div class="automated-email-filters-ui__header">
      <div class="automated-email-filters-ui__header-copy">
        <VHeading :level="3" class="auto-email-header">Filters</VHeading>
        <VHeading :level="4" class="auto-email-subheader">
          Define which properties and contacts automatic emails are generated for.
        </VHeading>
      </div>
      <div class="automated-email-filters-ui__header-action">
        <FiltersBtn @click="openFiltersModal()" />
      </div>
    </div>

    <div v-if="isLoading" class="automated-email-filters-ui__empty">Loading filters…</div>
    <div v-else-if="!groups.length" class="automated-email-filters-ui__empty">
      No filters configured.
    </div>
    <div v-else class="automated-email-filters-ui__rows">
      <div
        v-for="group in groups"
        :key="group.id"
        class="automated-email-filters-ui__row"
        role="button"
        tabindex="0"
        @click="openFiltersModal(GROUP_TAB_INDEX[group.id])"
        @keydown.enter.prevent="openFiltersModal(GROUP_TAB_INDEX[group.id])"
        @keydown.space.prevent="openFiltersModal(GROUP_TAB_INDEX[group.id])"
      >
        <span class="automated-email-filters-ui__row-label">{{ group.label }}</span>
        <div class="automated-email-filters-ui__badges">
          <span
            v-for="(badge, index) in group.badges"
            :key="`${group.id}-${index}`"
            class="automated-email-filters-ui__badge"
          >
            {{ badge }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  // Types
  import type { TListingFilters } from '~/misc/listings/types';
  import type { TAutomatedEmailFilterGroup } from '~/modules/opportunities/automated-email/settings/types';

  // Config
  import { GROUP_TAB_INDEX } from '~/modules/opportunities/automated-email/settings/filters/config';

  // Composables
  import useModal from '~/composables/use-modal';

  // Components
  import VHeading from '~/misc/v-heading/VHeading.vue';
  import FiltersBtn from '~/misc/btn/filters/FiltersBtn.vue';
  import AutomatedEmailFiltersModal from '~/modules/opportunities/automated-email/settings/filters/modal/AutomatedEmailFiltersModal.vue';

  const props = defineProps({
    groups: {
      type: Array as PropType<TAutomatedEmailFilterGroup[]>,
      required: true,
    },
    filters: {
      type: Object as PropType<TListingFilters>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    onApply: {
      type: Function as PropType<(filters: TListingFilters) => Promise<boolean>>,
      required: true,
    },
  });

  const { show: showModal } = useModal();

  const openFiltersModal = (initialTabIndex: number = 0) => {
    showModal(AutomatedEmailFiltersModal, {
      filters: props.filters,
      applyCallback: props.onApply,
      initialTabIndex,
    });
  };
</script>
